import { formatTel, withNamespace } from 'shared/lib';

export const ReadonlyField = ({ children }) => {
  return <div className='readonly-wrap'>{children}</div>;
};

const ValueField = ({ value }) => {
  return <span>{value || '-'}</span>;
};

const Item = ({ title, value }) => {
  return (
    <li className='confirm-info-item'>
      <div className='tit'>
        <span>{title}</span>
      </div>
      <div className='con'>
        <ValueField value={value} />
      </div>
    </li>
  );
};

const NameAndBirth = ({ usrNm, usrBirthday }) => {
  return (
    <ul className='confirm-info-list'>
      <Item title='이름' value={usrNm} />
      <Item title='생년월일' value={usrBirthday} />
    </ul>
  );
};

const TelList = ({ usrTelNo }) => {
  const telList = usrTelNo?.split('|') || ['-'];

  return (
    <ul className='confirm-info-list'>
      {telList.map((tel, index) => (
        <Item key={tel} title={`연락처${telList.length === 1 ? '' : index + 1}`} value={formatTel(tel)} />
      ))}
    </ul>
  );
};

const Address = ({ title, postNo, bscAddr, dtlAddr }) => {
  return (
    <ul className='confirm-info-list'>
      <li className='confirm-info-item'>
        <div className='tit'>
          <span>{title}</span>
        </div>
        <div className='con address-con'>
          <ValueField value={postNo} />
          {bscAddr && <ValueField value={bscAddr} />}
          {dtlAddr && <ValueField value={dtlAddr} />}
        </div>
      </li>
    </ul>
  );
};

export default withNamespace(ReadonlyField, {
  NameAndBirth,
  TelList,
  Address,
});
